import React, { lazy } from 'react';
import { authMenu, businessMenu, dashboardMenu, settingsMenu } from 'menu';

const AUTH = {
	LOGIN: lazy(() => import('pages/presentation/auth/AuthPage')),
	CONFIRM_SIGNUP: lazy(() => import('pages/presentation/auth/ConfirmSignup')),
	CONFIRM_LOGIN: lazy(() => import('pages/presentation/auth/Confirm2Fa')),
	FORGET_PASSWORD: lazy(() => import('pages/presentation/auth/Forget')),
	CONFIRM_RESET: lazy(() => import('pages/presentation/auth/ConfirmForget')),
	RESET_PASSWORD: lazy(() => import('pages/presentation/auth/ResetPassword')),
	JOIN_TEAM: lazy(() => import('pages/presentation/auth/JoinTeam')),
};

const LANDING = {
	GET_STARTED: lazy(() => import('pages/presentation/dashboard/Dashboard/GetStartedPage')),
	DASHBOARD: lazy(() => import('pages/presentation/dashboard/Dashboard/DashboardPage')),
	ALL_PROJECTS: lazy(() => import('pages/presentation/dashboard/Project/Projects')),
	SINGLE_PROJECT: lazy(() => import('pages/presentation/dashboard/Project/SingleProject')),
};

const BUSINESS = {
	WALLET: lazy(() => import('pages/presentation/business/Wallet/Wallets')),
	SINGLE_WALLET: lazy(() => import('pages/presentation/business/Wallet/SingleWallet')),
	SINGLE_INVOICE: lazy(() => import('pages/presentation/business/Wallet/SingleInvoice')),
	RECORDS: lazy(() => import('pages/presentation/business/Record/Records')),
	SINGLE_RECORD: lazy(() => import('pages/presentation/business/Record/SingleRecord')),
	VERIFY_DEPOSIT: lazy(() => import('pages/presentation/business/Wallet/VerifyPayment')),
	SINGLE_TRANSACTION: lazy(() => import('pages/presentation/business/Wallet/SingleTransaction')),
	NEW_VALIDATION: lazy(() => import('pages/presentation/business/Record/NewApiCall')),
};

const TEAM = {
	ALL_TEAM: lazy(() => import('pages/presentation/settings/Team/Team')),
	SINGLE_TEAM: lazy(() => import('pages/presentation/settings/Team/SingleTeam')),
	SINGL_ROLE: lazy(() => import('pages/presentation/settings/Team/SingleRole')),
	SINGL_INVITE: lazy(() => import('pages/presentation/settings/Team/SingleInvite')),
};

const OTHERS = {
	PLANS: lazy(() => import('pages/presentation/settings/Other/Plans')),
	API_KEYS: lazy(() => import('pages/presentation/settings/Other/ApiKey')),
};

const SETTINGS = {
	PROFILE: lazy(() => import('pages/presentation/profile/Profile')),
};

const presentation = [
	/**
	 * AUTH
	 */
	{
		path: authMenu.login.path,
		element: <AUTH.LOGIN />,
	},
	{
		path: authMenu.confirmSignUp.path,
		element: <AUTH.CONFIRM_SIGNUP />,
	},
	{
		path: authMenu.confirmLogin.path,
		element: <AUTH.CONFIRM_LOGIN />,
	},
	{
		path: authMenu.forgetGroup.subMenu.forgetPassword.path,
		element: <AUTH.FORGET_PASSWORD />,
	},
	{
		path: authMenu.forgetGroup.subMenu.confirmation.path,
		element: <AUTH.CONFIRM_RESET />,
	},
	{
		path: authMenu.forgetGroup.subMenu.resetPassword.path,
		element: <AUTH.RESET_PASSWORD />,
	},
	{
		path: authMenu.joinTeam.path,
		element: <AUTH.JOIN_TEAM />,
	},
	/**
	 * Landing
	 */
	{
		path: dashboardMenu.getStarted.path,
		element: <LANDING.GET_STARTED />,
	},
	{
		path: dashboardMenu.dashboard.path,
		element: <LANDING.DASHBOARD />,
	},
	{
		path: dashboardMenu.projects.path,
		element: <LANDING.ALL_PROJECTS />,
	},
	{
		path: `${dashboardMenu.projects.path}/:id`,
		element: <LANDING.SINGLE_PROJECT />,
	},
	/**
	 * Business
	 */
	{
		path: businessMenu.wallet.path,
		element: <BUSINESS.WALLET />,
	},
	{
		path: businessMenu.records.path,
		element: <BUSINESS.RECORDS />,
	},
	{
		path: `${businessMenu.records.path}/:id`,
		element: <BUSINESS.SINGLE_RECORD />,
	},
	{
		path: `${businessMenu.wallet.path}/:id`,
		element: <BUSINESS.SINGLE_WALLET />,
	},
	{
		path: `${businessMenu.wallet.path}/invoices/:id`,
		element: <BUSINESS.SINGLE_INVOICE />,
	},
	{
		path: businessMenu.verifyDeposit.path,
		element: <BUSINESS.VERIFY_DEPOSIT />,
	},
	{
		path: `${businessMenu.wallet.path}/transactions/:id`,
		element: <BUSINESS.SINGLE_TRANSACTION />,
	},
	{
		path: businessMenu.apiCalls.path,
		element: <BUSINESS.NEW_VALIDATION />,
	},
	// Settings
	{
		path: settingsMenu.team.path,
		element: <TEAM.ALL_TEAM />,
	},
	{
		path: `${settingsMenu.team.path}/:id`,
		element: <TEAM.SINGLE_TEAM />,
	},
	{
		path: `${settingsMenu.team.path}/roles/:id`,
		element: <TEAM.SINGL_ROLE />,
	},
	{
		path: `${settingsMenu.team.path}/invites/:id`,
		element: <TEAM.SINGL_INVITE />,
	},
	{
		path: settingsMenu.plans.path,
		element: <OTHERS.PLANS />,
	},
	{
		path: settingsMenu.apiKeys.path,
		element: <OTHERS.API_KEYS />,
	},
	{
		path: settingsMenu.profile.path,
		element: <SETTINGS.PROFILE />,
	},
];
const contents = [...presentation];

export default contents;
